import "@/styles/globals.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "@/styles/slick-overrides.css";
import "../builder/register";
import type { AppProps } from "next/app";
import { useTrackingParams } from "@/hooks/useTrackingParams";
import { Montserrat, Crimson_Text, Crimson_Pro } from "next/font/google";

const montserrat = Montserrat({
  subsets: ["latin"],
  weight: ["300", "400", "500", "600", "700"],
  display: "swap",
  variable: "--font-montserrat",
});

const crimsonText = Crimson_Text({
  subsets: ["latin"],
  weight: ["400", "600", "700"],
  display: "swap",
  variable: "--font-crimson-text",
});

const crimsonPro = Crimson_Pro({
  subsets: ["latin"],
  weight: ["200", "300", "400", "500", "600", "700", "800", "900"],
  display: "swap",
  variable: "--font-crimson-pro",
});

export default function App({ Component, pageProps }: AppProps) {
  useTrackingParams();

  return (
    <div
      className={`${montserrat.variable} ${crimsonText.variable} ${crimsonPro.variable} font-sans`}
    >
      <Component {...pageProps} />
    </div>
  );
}
